var React = require('react');

function White (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"11","cy":"11","r":"10","stroke":"#fff","strokeLinecap":"round","strokeWidth":"1","key":0}),React.createElement("path",{"fill":"#fff","d":"M10.733 17.803a5.49 5.49 0 0 0-.436-2.143 5.594 5.594 0 0 0-1.243-1.817 5.74 5.74 0 0 0-1.858-1.214 5.846 5.846 0 0 0-2.193-.426v5.6h5.73Z","key":1}),React.createElement("ellipse",{"cx":"15.03","cy":"6.603","fill":"#fff","rx":"1.432","ry":"1.6","key":2}),React.createElement("path",{"fill":"#fff","d":"M16.463 17.789a10.959 10.959 0 0 0-.856-4.296 11.084 11.084 0 0 0-2.475-3.635 11.38 11.38 0 0 0-3.719-2.42 11.671 11.671 0 0 0-4.396-.835l-.014 3.09a8.462 8.462 0 0 1 3.187.606 8.25 8.25 0 0 1 2.696 1.754 8.036 8.036 0 0 1 1.795 2.635c.414.986.625 2.045.62 3.115l3.162-.014Z","key":3})]);
}

White.defaultProps = {"width":"24","height":"24","fill":"none","viewBox":"0 0 24 24"};

module.exports = White;

White.default = White;
